import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './app/App';
import '@moneyskyline/brand/tokens.css';
import './styles/index.css';

const container = document.getElementById('root');
if (!container) throw new Error('root element missing');

// Dev-only fixture harness (execution plan §5.4): reachable ONLY at
// `/__dev/:screen` and ONLY in a dev build. `routeManifest.ts` never
// declares this path -- it is not part of the routed app at all, so it
// cannot ship in a production bundle by accident.
const isDevHarnessPath = import.meta.env.DEV && window.location.pathname.startsWith('/__dev');

async function render() {
  if (isDevHarnessPath) {
    const { FixtureHarness } = await import('./dev/FixtureHarness');
    createRoot(container!).render(
      <StrictMode>
        <FixtureHarness />
      </StrictMode>,
    );
    return;
  }

  createRoot(container!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void render();
